module.exports = __webpack_public_path__ + "static/media/Chair1_After.28bcbe78.jpg";